export { default } from './SliderTextInput'
